import { joinPath } from "./joinPath";

/**
 * Resolves relative URLs against API base URL. Returns absolute URLs as-is.
 *
 * @param {string} path - The path to resolve.
 */
export function apiPath(path, apiBase) {
  // Return absolute URLs as-is.
  if (/^https?:\/\//.test(path)) {
    return path;
  }

  // Otherwise append path to API base URL.
  return joinPath(apiBase, path);
}
